<template>
  <Message class="invitation-item" severity="info" :closable="false">
    <div class="flex items-center justify-between">
      <div>
        Vous êtes invité sur le projet "{{ invitation.project.title }}" de
        {{ invitation.project.creator.username }} en tant {{ invitation.is_admin ? "qu'administrateur" : "que membre" }}.
      </div>
      <div class="flex gap-5">
        <Button @click="$emit('accept')" label="Accepter" icon="mdi-check" class="btn-green" />
        <Button @click="$emit('decline')" label="Refuser" icon="mdi-close" class="btn-red" />
      </div>
    </div>
  </Message>
</template>

<script>
export default {
  props: ["invitation"],
};
</script>

<style>
.invitation-item .p-message-text {
  width: 100%;
}
</style>
